import { Dialog } from '@mui/material';
import { ButtonComponent } from 'component/Button';
import { React, useState } from 'react';
import { ReactComponent as CancelSvg } from 'assets/images/icons/close_24px.svg';
import { ReactComponent as AddSvg } from 'assets/images/icons/add_24px.svg';
import { InputComponent } from 'component/Input';
import { TextareaComponent } from 'component/Textarea';
import { SelectComponent } from 'component/Select';
import { SwitherComponent } from 'component/Swither';
import { axiosWrapper } from 'utils/Helper';
import { createCustomer, getOrganizations } from 'api/CustomersApi';
import { toast } from 'react-toastify';

function NewCustomer(props) {
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [organizationsLoading, setOrganizationsLoading] = useState(false);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);

  const loadOrganizations = function () {
    setOrganizationOptions([]);
    setOrganizationsLoading(true);
    axiosWrapper(function () {
      getOrganizations()
        .then(function (res) {
          const list = res?.data?.results ?? res?.data;
          const arr = Array.isArray(list) ? list : [];
          const options = arr.map((organization) => {
            const label =
              organization.full_name_uk?.trim() ||
              organization.name ||
              organization.abbreviation ||
              String(organization.id);
            return { value: organization.id, label };
          });
          setOrganizationOptions(options);
        })
        .catch(function () {
          setOrganizationOptions([]);
        })
        .finally(function () {
          setOrganizationsLoading(false);
        });
    });
  };

  const handleClickOpen = function () {
    setOpen(true);
    setDescription('');
    setIsActive(true);
    setSelectedOrganizations([]);
    loadOrganizations();
  };

  const handleClose = function () {
    setOpen(false);
    props.setName(null);
    setDescription('');
    setIsActive(true);
    setSelectedOrganizations([]);
  };

  const handleOrganizationsSelect = function (selected) {
    setSelectedOrganizations(Array.isArray(selected) ? selected : []);
  };

  const createNewCustomer = function () {
    if (!props.name || !props.name.trim()) {
      toast.warning('You need to set customer name');
      return;
    }
    if (!selectedOrganizations.length) {
      toast.warning('Select at least one organization');
      return;
    }
    const organizationIds = selectedOrganizations.map((option) => option.value);
    props.setLoader(true);
    axiosWrapper(function () {
      const body = {
        name: props.name.trim(),
        is_active: isActive,
        description: description.trim() || undefined,
        organizations: organizationIds,
      };
      createCustomer(body)
        .then(function () {
          toast.success('Customer created');
          props.setLoader(false);
          props.getCustomersList(1);
          handleClose();
        })
        .catch(function (err) {
          console.error(err);
          toast.error(
            err && err.response && err.response.data && err.response.data.detail
              ? err.response.data.detail
              : 'Customer not created'
          );
          props.setLoader(false);
        });
    });
  };

  return (
    <div className="buttons-group">
      <ButtonComponent
        iconLeft={<AddSvg />}
        handleButton={handleClickOpen}
        label="New customer"
        className=""
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="confirm-popup customer-form-popup">
          <div className="header">
            <span className="title">Create customer</span>
            <span className="closeBtn" onClick={handleClose} />
          </div>

          <div className="flex-column-group">
            <InputComponent
              id="customer-name"
              name="customer-name"
              label="Customer name"
              placeholder="Customer name"
              value={props.name}
              handleInput={props.setName}
              classNameWrapper="align-left"
            />
            <div className="input-wrapper align-left w-100" style={{ marginTop: '10px' }}>
              <div className="labels">
                <label htmlFor="textarea-customer-users-detail">Description</label>
              </div>
              <div className="textarea-wrapper w-100">
                <TextareaComponent
                  id="customer-users-detail"
                  name="description"
                  placeholder="Description"
                  value={description}
                  handleTextarea={setDescription}
                  style={{ minHeight: '80px', width: '100%', boxSizing: 'border-box' }}
                />
              </div>
            </div>
            <div className="org-dialog-status-row" style={{ marginTop: '10px' }}>
              <SwitherComponent
                checked={isActive}
                handleSwitcher={setIsActive}
                labelLeft="Inactive"
                labelRight="Active"
              />
            </div>
            <div className="select-wrapper w-100" style={{ marginTop: '10px' }}>
              <span className="label">Organizations</span>
              <SelectComponent
                className="w-100"
                placeholder="Select organizations..."
                value={selectedOrganizations}
                options={organizationOptions}
                handleSelect={handleOrganizationsSelect}
                isMulti
                menuPortalTarget={document.body}
                menuPosition="fixed"
                noOptionsMessage={() => (organizationsLoading ? 'Loading...' : 'No organizations')}
                customStyles={{
                  menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                  menu: (base) => ({ ...base, zIndex: 2000 }),
                }}
              />
            </div>
          </div>

          <div className="buttons-group">
            <ButtonComponent
              className="danger"
              iconLeft={<CancelSvg />}
              handleButton={handleClose}
              label="Close"
            />
            <ButtonComponent
              iconLeft={<AddSvg />}
              handleButton={createNewCustomer}
              label="Create"
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export { NewCustomer };
